import { useOktaAuth } from '@okta/okta-react';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLogin } from './app/loginSlice';
import { getRoles } from './utils/loginUtil';
import { totalClearUsers, dispatchUsersForRole, dispatchUsersForAllRoles } from './app/usersSlice';
import { clearActivities } from './app/activitiesSlice';
import { clearAchievements } from './app/achievementsSlice';
import { Box, Typography, CircularProgress } from '@mui/material';

const LoginIdp = ({ onLogin }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();
  const [showSplash, setShowSplash] = useState(false); // State for splash screen
  const [freshLogin, setFreshLogin] = useState(false); // State to track fresh login

  const login = async () => oktaAuth.signInWithRedirect();
  const logout = async () =>
    oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin + '/',
    });

  const isLoggedIn = authState && authState.isAuthenticated;

  const setLogout = () => {
    window._loginEmail = '';
    window._loginRights = {};
    window._accessToken = '';
    dispatch(clearActivities());
    dispatch(clearAchievements());
    dispatch(totalClearUsers());
    dispatch(setLogin({ email: '', rights: {}, roles: [], selectedRole: '', coreId: '', accessToken: '' }));
    if (onLogin) {
      onLogin(false);
    }
  };

  const handleLogin = async (email, accessToken) => {
    let user = await oktaAuth.getUser();

    if (email.endsWith('@motorolasolutions.com')) {

      setFreshLogin(true);
      setShowSplash(true);

      window._loginEmail = email;
      window._accessToken = accessToken;
      window._loginUserName = user.name;

      const rolesResponse = await getRoles(email);
      const rights = {
        admin: rolesResponse.isAdmin,
        manager: rolesResponse.isManager,
        user: rolesResponse.isUser,
      };

      if (!rolesResponse.isAdmin && !rolesResponse.isManager && !rolesResponse.isUser) {
        setLogout();
        return;
      }

      const roles = [];
      if (rolesResponse.isUser) {
        roles.push('User');
      }
      if (rolesResponse.isManager) {
        roles.push('Manager');
      }
      if (rolesResponse.isAdmin) {
        roles.push('Admin');
      }

      window._loginRights = rights;
      const selectedRole = roles[0];
      let coreId = rolesResponse?.userObj?.coreId || '';

      //Make a request to add the user to the JSON file if they are not already present
      fetch('https://lxxzfrffz5.execute-api.us-east-1.amazonaws.com/Prod/addUserToJsonIfNeeded', {
      // fetch('http://127.0.0.1:3000/addUserToJsonIfNeeded', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify({
          name: user.name,
          email: user.email,
          coreid: coreId,
          parent: "",
          teamname: ""
        })
      }).then(response => {
        if (!response.ok) {
          console.log('Error when adding user to JSON', response.statusText);
        }
        else {
          console.log('User added to JSON successfully');
        }
      });

      await dispatch(setLogin({ email, rights, roles, selectedRole, coreId, accessToken }));
      dispatchUsersForAllRoles(dispatch, rolesResponse.allUsers, rolesResponse.managedUsers, rolesResponse.userObj);
      dispatchUsersForRole(dispatch, selectedRole, rolesResponse.allUsers, rolesResponse.managedUsers, rolesResponse.userObj);

      if (onLogin) {
        setTimeout(() => {
          setShowSplash(false);
          setFreshLogin(false);
          onLogin(true);
        }, 750);
      }
    } else {
      setLogout();
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      let email = '?',
        rights = '?',
        roles = '?',
        selectedRole = '?',
        coreId = '?';
      let accessToken = authState?.accessToken?.accessToken || '';
      if (authState.idToken && authState.idToken.claims) {
        email = authState.idToken.claims.preferred_username || authState.idToken.claims.email;
        rights = authState.idToken.claims.rights;
        roles = authState.idToken.claims.roles;
        selectedRole = authState.idToken.claims.selectedRole;
        coreId = authState.idToken.claims.coreid;
      }

      // Only call handleLogin if this is a fresh login
      if (!freshLogin) {
        handleLogin(email, accessToken);
      }
    } else {
      setLogout();
    }
  }, [isLoggedIn]);

  if (!authState) {
    return null;
  }

  return (
    <>
      {showSplash && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            color: 'white',
            flexDirection: 'column',
          }}
        >
        <img
          src="/SPLASH.png"
          alt="Splash Screen Logo"
          style={{ width: '150px', marginBottom: '20px' }}
        />
        </Box>
      )}
    </>
  );
};

export default LoginIdp;